<div class="retrieve-instructions-container">
  <h3 class="section-title">What to do:</h3>
  <p class="instruction-message">
    Find studies received from other facilities. Search by Patient Name, Patient ID, or any available filter.
  </p>
</div>
